import React from 'react';
import PropTypes from 'prop-types';

const chip = (background, color) => ({
  marginTop: 6, padding: '4px 8px', backgroundColor: background, borderRadius: 4, fontSize: 10, color, textAlign: 'center',
});

// Whether an alert line's price alert is armed (DWLF-580). A line with an arm error, or with no alert and
// no arm running, offers Retry; a line still being created shows nothing yet.
const AlertLineStatus = ({ annotation, onRearmAlert }) => {
  const { id, alertId, triggered, _alertError: alertError, _alertArming: arming } = annotation;
  if (triggered) {
    return <div style={chip('var(--dwlf-ink-10)', 'var(--dwlf-ink-60)')}>✓ Alert has been triggered</div>;
  }
  if (alertId && !alertError) {
    return <div style={chip('var(--dwlf-warn-10)', 'var(--dwlf-warn)')}>🔔 Alert active</div>;
  }
  if (id.startsWith('_tmp_')) return null;
  if (arming && !alertError) {
    return <div role="status" style={chip('var(--dwlf-ink-10)', 'var(--dwlf-ink-60)')}>Arming alert…</div>;
  }
  return (
    <div role="alert" style={chip('var(--dwlf-down-10)', 'var(--dwlf-down)')}>
      {alertId ? '⚠ Alert not updated' : '⚠ Alert not armed'}{alertError ? `: ${alertError}` : ''}
      {onRearmAlert && (
        <button
          type="button"
          onClick={() => onRearmAlert(id)}
          disabled={!!arming}
          style={{ marginLeft: 6, fontSize: 10, cursor: 'pointer', color: 'inherit', background: 'none', border: '1px solid currentColor', borderRadius: 3, padding: '0 6px' }}
        >
          {arming ? 'Arming…' : 'Retry'}
        </button>
      )}
    </div>
  );
};

AlertLineStatus.propTypes = {
  annotation: PropTypes.shape({
    id: PropTypes.string.isRequired,
    alertId: PropTypes.string,
    triggered: PropTypes.bool,
    _alertError: PropTypes.string,
    _alertArming: PropTypes.bool,
  }).isRequired,
  onRearmAlert: PropTypes.func,
};

export default AlertLineStatus;
